import { Loader2 } from "lucide-react";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAccessPermissions } from "@/hooks/useAccessPermissions";
import { AccessPeopleTab } from "@/components/admin/access/AccessPeopleTab";
import { AccessRolesTab } from "@/components/admin/access/AccessRolesTab";
import { AccessLogTab } from "@/components/admin/access/AccessLogTab";

export default function AdminAccess() {
  const { can, isLoading } = useAccessPermissions();
  const canManage = can("roles.manage");

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold">Roles & Access</h1>
          <p className="text-sm text-muted-foreground">Decide who can do what, and where.</p>
        </div>
        {isLoading ? (
          <div className="flex justify-center py-16"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>
        ) : (
          <Tabs defaultValue="people">
            <TabsList>
              <TabsTrigger value="people">People</TabsTrigger>
              <TabsTrigger value="roles">Roles</TabsTrigger>
              <TabsTrigger value="log">Access log</TabsTrigger>
            </TabsList>
            <TabsContent value="people"><AccessPeopleTab canManage={canManage} /></TabsContent>
            <TabsContent value="roles"><AccessRolesTab canManage={canManage} /></TabsContent>
            <TabsContent value="log"><AccessLogTab /></TabsContent>
          </Tabs>
        )}
      </div>
    </DashboardLayout>
  );
}
